import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { locale } from 'devextreme/localization';
import config from 'devextreme/core/config';
import { licenseKey } from './devextreme-license';

import { AppModule } from './app/app.module';
import { environment } from 'environments/environment';

config({ licenseKey });

if (environment.production) {
  enableProdMode();
}

locale('en-IN');

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(reg => reg.unregister());
  });
}

if ('caches' in window) {
  caches.keys().then(keys => {
    keys.forEach(key => {
      if (key.startsWith('ngsw:')) {
        caches.delete(key);
      }
    });
  });
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));